// ======================================================================
// File Name       : LiveperformanceListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import LivePerformanceSearchForm from '../../components/livePerformance/LivePerformanceSearchForm';
import LivePerformanceListForm from '../../components/livePerformance/LivePerformanceListForm';
import * as LivePerformanceAction from '../../actions/LivePerformanceAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { VALIDATE_TYPE, RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER_NO_SECOND } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import { USER_HISTORY_LIVE_PERFORMANCE_LIST, USER_HISTORY_LIVE_PERFORMANCE_DETAIL } from '../../constants/PathConstants';
import MessageSearch from '../../components/MessageSearch';
import * as actionType from '../../constants/actionTypes/page';

class LivePerformanceListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {
        liveSortType: null,
        ascendingDescendingSort: null,
        startPosition: 0,
        userSecernId: '',
        liveStartFrom: null,
        liveStartTo: null,
        returnMaxNum: RETURN_MAX_NUM,
        userAttributeKeyNum: 1,
        userAttributeSearchText: '',
        liveName: '',
        organizerUserName: '',
      },
      recordNum: 0,
      liveList: [],
      livePerformanceObj: {},
      isAllowShowSearchMessage: false,
    };
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.initData = this.initData.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.searchData = this.searchData.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { searchCondition } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: USER_HISTORY_LIVE_PERFORMANCE_LIST,
      searchCondition: formValues,
    });
  }
    /**
     *       Search Data
    */
  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.liveSortType) {
        column = initialValues.liveSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, column, startPosition);
    this.props.dispatch(LivePerformanceAction.searchLivePerformanceList(param));
  }

  goToDetail(liveSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: USER_HISTORY_LIVE_PERFORMANCE_LIST,
        searchCondition: formValues,
      });
    }
    const path = USER_HISTORY_LIVE_PERFORMANCE_DETAIL.replace(':id', liveSecernId);
    this.props.history.push(path);
  }

  /**
   * Paging
   */
  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.liveSortType) {
      column = formValues.liveSortType;
    }
    this.searchData(startPosition, column);
  }
  /**
   * Handle sort table
   */
  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

    /**
     * Search button
     */
  searchData(startPosition, column) {
    const { filterData } = this.state;
    const { invalid, dispatch, formValues } = this.props;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(filterData, column, startPosition);
    this.props.dispatch(LivePerformanceAction.searchLivePerformanceList(paramSearch)).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      startPosition: formValues.startPosition,
      liveSortType: formValues.liveSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      userSecernId: formValues.userSecernId,
      liveStartFrom: formValues.liveStartFrom,
      liveStartTo: formValues.liveStartTo,
      userAttributeKeyNum: formValues.userAttributeKeyNum,
      userAttributeSearchText: formValues.userAttributeSearchText,
      liveName: formValues.liveName,
      organizerUserName: formValues.organizerUserName,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('liveSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(LivePerformanceAction.searchLivePerformanceList(paramSearch)).then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  createParams(data, column, startPosition) {
    const filterData = {
      ...data,
      includeCompletedLive: 1,
      userSecernId: data.userSecernId,
    };

    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.liveSortType = column.sortBy;
    }

    if (data ) {
        filterData.liveStartFrom = data.liveStartFrom ? moment(data.liveStartFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER_NO_SECOND) : '';
        filterData.liveStartTo = data.liveStartTo ? moment(data.liveStartTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER_NO_SECOND) : '';
    }
    if (!column) {
      filterData.ascendingDescendingSort = null;
      filterData.liveSortType = null;
    }
    filterData.returnMaxNum = RETURN_MAX_NUM;
    const param = {
      searchInfo: filterData,
    };
    return param;
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { livePerformanceObj, liveList, recordNum } = this.props;
    const liveArray = livePerformanceObj && livePerformanceObj.allSecernIds && Object.keys(livePerformanceObj.allSecernIds).length ? livePerformanceObj.allSecernIds : [];
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={liveArray}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <LivePerformanceSearchForm
          {...this.props.filterData}
          onSearchBtnClick={this.props.handleSubmit(this.clickSearchButton)}
        />
        <LivePerformanceListForm
          livePerformanceListObj={livePerformanceObj}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          recordNum={recordNum}
          getStartEndData={this.getStartEndData}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { liveList, livePerformanceObj, recordNum } = state.userHistoryLivePerformance;
  const { initialData } = state.userHistoryLivePerformance;
  const { livePerformanceList } = state.form;
  const { parentPath, searchCondition } = state.page;
  const formValues = getFormValues('livePerformanceList')(state);
  const invalid = isInvalid('livePerformanceList')(state);
  // #6084 START
  let initial = {
    userAttributeKeyNum: 1,
  };
  // #6084 END

  if (parentPath === USER_HISTORY_LIVE_PERFORMANCE_LIST) {
    if (searchCondition) {
      const paramSearch = {};
      paramSearch.liveSortType = searchCondition.liveSortType;
      paramSearch.ascendingDescendingSort = searchCondition.ascendingDescendingSort;
      paramSearch.startPosition = searchCondition.startPosition;
      paramSearch.userSecernId = searchCondition.userSecernId;
      paramSearch.liveStartFrom = searchCondition.liveStartFrom;
      paramSearch.liveStartTo = searchCondition.liveStartTo;
      paramSearch.userAttributeKeyNum = searchCondition.userAttributeKeyNum;
      paramSearch.userAttributeSearchText = searchCondition.userAttributeSearchText;
      paramSearch.liveName = searchCondition.liveName;
      paramSearch.organizerUserName = searchCondition.organizerUserName;
      initial = paramSearch;
    }
  }
  return {
    ...{ liveList },
    ...{ livePerformanceObj },
    formValues,
    initialValues: initial,
    recordNum,
    invalid,
    searchCondition,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'livePerformanceList', // a unique identifier for this form
  touchOnChange: true,
})(LivePerformanceListContainer));
